import { render, staticRenderFns } from "./BeCustomerCard.vue?vue&type=template&id=3e382ffe&scoped=true"
import script from "./BeCustomerCard.vue?vue&type=script&lang=js"
export * from "./BeCustomerCard.vue?vue&type=script&lang=js"
import style0 from "./BeCustomerCard.vue?vue&type=style&index=0&id=3e382ffe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e382ffe",
  null
  
)

export default component.exports